import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

export const MainPanelContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  gap: 16px;
  width: 100%;
  border-radius: 4px;

  @media ${media.belowTablet} {
    flex-direction: column;
    gap: 12px;
  }
`
MainPanelContent.displayName = 'MainPanelContent'
